<template>
  <div style="width: 600px; margin: 40px auto;">
    <el-row style="margin-top:30px;" :gutter="20">
      <el-col :span="12">
        <el-link :underline="false" href="http://web.letiao.com/cv">
          <div class="image-container">
            <img :src="require('~/assets/images/job.png')" width="40" alt="找工作" title="找工作" />
          </div>
          <span class="title">我要找工作</span>
          <span class="memo">求职者登录</span>
        </el-link>
      </el-col>
      <el-col :span="12">
        <el-link :underline="false" href="http://web.letiao.com/ent">
          <div class="image-container">
            <img :src="require('~/assets/images/talent.png')" width="40" alt="招人" title="招人" />
          </div>
          <span class="title">我要招人</span>
          <span class="memo">企业端登录</span>
        </el-link>
      </el-col>
    </el-row>
    <el-divider class="divider"></el-divider>
    <p>
      <el-link @click="isRegist = !isRegist" type="primary">还没账号？微信快速注册</el-link>
    </p>
    <div style="margin-top:10px" v-if="isRegist">
      <img :src="require('~/assets/images/qrcode.png')" width="200" alt="请关注：‘乐跳会员’公众号" title="乐跳会员公众号" />
      <p style="font-size: 14px; line-height: 24px;">请用微信“扫一扫”扫描上方二维码</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isRegist: false
      };
    }
  };
</script>

<style scoped>
  .image-container {
    margin: 0 auto;
    width: 40px;
    height: 40px;
  }

  .title {
    display: block;
    font-size: 24px;
    line-height: 46px;
  }

  .memo {
    display: block;
    color: #999999;
    font-size: 14px;
    line-height: 22px;
  }

  .divider {
    margin: 70px 0;
  }
</style>